/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState, useEffect, useRef } from "react";
import AuditInfoCard from "./AuditData";
import AuditInfo from "./AuditInfo";
import { Card } from "react-bootstrap";
import GeneralAuditDetailsCard from "./GeneralAudit";
import TimeLineCard from "./TimeLineView";
import ProgressMetricsCard from "./ProgressMterics";
import { PulseLoader } from "react-spinners";
import FindingsAnsIssueCard from "./FindingsandIssue";
import ResourceCard from "./ResourceUtilization";
import AuditQuality from "./AuditQuality";
import EscalationDetailsCard from "./Escalation";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import GeneralAuditIcon from "../../icons/GeneralAuditIcon.svg";
import TimeLineIcon from "../../icons/TimeLineIcon.svg";
import ProgressMetricsIcon from "../../icons/ProgressMetricsIcon.svg";
import styles from "./style.module.scss";
import CustomAccordion from "../../Components/Accordion";
import { encrypt } from "../../utils";
import AuditAnalytics from "./AuditAnalytics";
interface StateProps {
  auditInfoData: any;
  timeLineData: any;
  findIssueChartData: any;
  escalationData: any;
  progressData: any;
  cardLoading: boolean;
  handleFindingChartClick: (id: number, severity: string) => void;
  FindingstableLoading: boolean;
  FindingstableData: any;
  generalInfo: any;
  resourceUtilData: any;
  responseAnalysisData: any;
  responseAnalysisThemeData: any;
  getTabDetails?: (tab: string, id: number) => void;
}

const AuditorDashboard: FC<StateProps> = ({
  auditInfoData,
  timeLineData,
  findIssueChartData,
  handleFindingChartClick,
  FindingstableLoading,
  FindingstableData,
  escalationData,
  progressData,
  getTabDetails,
  generalInfo,
  resourceUtilData,
  responseAnalysisData,
  responseAnalysisThemeData,
  cardLoading,
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(0);
  const [shrinkAll, setShrinkAll] = useState(false);
  const [selectedTab, setSelectedTab] = useState("General Details");
  const [selectedAuditId, setSelectedAuditId] = useState<number>(0);
  const scrollRef = useRef<HTMLDivElement>(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const scrollAmount = 800; // Equal to card width

  useEffect(() => {
    if (auditInfoData.length > 0) {
      setSelectedAuditId(auditInfoData[0]?.id);
      getTabDetails?.("General Details", auditInfoData[0]?.id);
    }
  }, [auditInfoData]);

  const handleCardClick = (index: number, id: number) => {
    setSelectedTab("General Details");
    setSelectedAuditId(id);
    setShrinkAll(false);
    setSelectedIndex(index);
    getTabDetails?.("General Details", id);
  };
  const isInProgress =
    auditInfoData.filter((data: any) => data.id === selectedAuditId)[0]
      ?.status === "In Progress";
  const renderTabContent = () => {
    switch (selectedTab) {
      case "General Details":
        return (
          <div className="bg-white p-3 rounded">
            <CustomAccordion
              Data={[
                {
                  title: (
                    <span>
                      <img
                        className="mx-2"
                        src={GeneralAuditIcon}
                        width={"18px"}
                        alt="no"
                      />
                      General Details
                    </span>
                  ),
                  content: (
                    <div>
                      <GeneralAuditDetailsCard
                        auditId={timeLineData ? timeLineData.auditCode : "-"}
                        auditTeam={generalInfo}
                        scope={generalInfo?.scopeAndObjective}
                        auditType={generalInfo?.auditType}
                        status={generalInfo?.status}
                        auditorMembers={generalInfo?.auditorMembers}
                        auditeeMembers={generalInfo?.auditeeMembers}
                      />
                    </div>
                  ),
                },
                {
                  title: (
                    <span>
                      <img
                        className="mx-2"
                        src={TimeLineIcon}
                        width={"18px"}
                        alt="no"
                      />
                      Timeline View
                    </span>
                  ),
                  content: (
                    <TimeLineCard
                      auditCreatedDate={timeLineData?.auditCreatedDate}
                      startDate={timeLineData?.startDate}
                      endDate={timeLineData?.endDate}
                      actualStartDate={timeLineData?.actualStartDate}
                      actualEndDate={timeLineData?.actualEndDate}
                      scheduled={timeLineData?.scheduled}
                      inProgress={timeLineData?.inProgress}
                      closure={timeLineData?.closure}
                      currentStage={timeLineData?.currentStage}
                      completionPercent={timeLineData?.completionPercent}
                    />
                  ),
                },
                {
                  title: (
                    <span>
                      <img
                        className="mx-2"
                        src={ProgressMetricsIcon}
                        width={"18px"}
                        alt="no"
                      />
                      Progress Metrics
                    </span>
                  ),
                  content: (
                    <ProgressMetricsCard
                      overAllCompletion={progressData?.overAllCompletion}
                      taskCompletion={progressData?.taskCompletion}
                      phaseWiseProgress={progressData?.phaseWiseProgress}
                    />
                  ),
                },
              ]}
            />
          </div>
        );
      case "Questionnaire Analysis":
        return auditInfoData.filter(
          (data: any) => data.id === selectedAuditId
        )[0]?.status === "In Progress" ||
          auditInfoData.filter((data: any) => data.id === selectedAuditId)[0]
            ?.status === "Completed" ? (
          <div>
            <AuditAnalytics
              responseAnalysisData={responseAnalysisData ?? []}
              responseAnalysisThemeData={responseAnalysisThemeData ?? []}
              auditID={selectedAuditId}
            />
          </div>
        ) : (
          <div className="p-3">
            Questionnaire Analysis will be available once the audit moves to the
            In-Progress stage.
          </div>
        );
      case "Findings & Issues":
        return (
          <div>
            <FindingsAnsIssueCard
              findIssueChartData={findIssueChartData}
              selectedAuditId={selectedAuditId}
              handleFindingChartClick={handleFindingChartClick}
              tableLoading={FindingstableLoading}
              tableData={FindingstableData}
            />
          </div>
        );
      case "Escalations":
        return (
          <div>
            <div className="p-3">
              <EscalationDetailsCard
                escalations={escalationData?.escalationInfo}
                escalationscount={escalationData?.totalEscalationQuestionCount}
              />
            </div>
          </div>
        );
      case "Resource Utilization":
        return (
          <div>
            <ResourceCard resourceUtilData={resourceUtilData} />
          </div>
        );
      case "Audit Quality Metrics":
        return (
          <div>
            <AuditQuality />
          </div>
        );
      default:
        return <div>Select a tab to see content</div>;
    }
  };

  const checkScrollPosition = () => {
    const container = scrollRef.current;
    if (container) {
      const { scrollLeft, scrollWidth, clientWidth } = container;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1); // avoid float errors
    }
  };

  const handleScrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  };

  const handleScrollRight = () => {
    scrollRef.current?.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    checkScrollPosition();

    const handleScroll = () => checkScrollPosition();

    container.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [auditInfoData]);

  return (
    <>
      <div>
        <h6
          className=" d-flex justify-content-start fw-bold mb-0"
          style={{ fontSize: "15px", color: "#102250" }}
        >
          Ongoing Audits
        </h6>
      </div>
      <div
        className="position-relative"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Scrollable Cards Container */}
        <div
          className="d-flex overflow-hidden mt-3 custom_scroll"
          style={{ gap: "1rem", scrollBehavior: "smooth" }}
          ref={scrollRef}
        >
          {auditInfoData?.map((info: any, index: any) => (
            <div
              className="flex-shrink-0 pb-3"
              style={{ width: "490px" }}
              key={index}
            >
              <AuditInfoCard
                {...info}
                selected={selectedIndex === index}
                shouldShrink={shrinkAll}
                onClick={() => handleCardClick(index, info?.id)}
              />
            </div>
          ))}
        </div>

        {/* Left Arrow (overlay) */}
        {canScrollLeft && isHovered && (
          <button
            className={`${styles.scroll_arrow} ${styles.left_arrow}`}
            onClick={handleScrollLeft}
          >
            <FaChevronLeft size={24} />
          </button>
        )}

        {/* Right Arrow (overlay) */}
        {canScrollRight && isHovered && (
          <button
            className={`${styles.scroll_arrow} ${styles.right_arrow}`}
            onClick={handleScrollRight}
          >
            <FaChevronRight size={24} />
          </button>
        )}
      </div>
      <div className="d-flex mt-3" style={{ gap: "1rem" }}>
        <AuditInfo
          selected={selectedTab}
          auditInfoData={auditInfoData}
          onClick={(selection: string) => {
            setSelectedTab(selection);
            setShrinkAll(true);
            getTabDetails?.(selection, selectedAuditId);
          }}
        />
      </div>
      <Card
        className={`my-3 transparentBorder ${selectedTab === "General Details" ? "audit-tab-card-general" : ""}`}
      >
        {cardLoading ? (
          <div
            style={{
              height: "250px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PulseLoader size={20} color="#4a4a4a" />
          </div>
        ) : (
          renderTabContent()
        )}
      </Card>
    </>
  );
};

export default AuditorDashboard;
